import { render } from "./MLEForm.vue?vue&type=template&id=24b0faff&scoped=true"
import script from "./MLEForm.vue?vue&type=script&lang=js"
export * from "./MLEForm.vue?vue&type=script&lang=js"

import "./MLEForm.vue?vue&type=style&index=0&id=24b0faff&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b0faff"]])

export default __exports__